import React from 'react'
import { Box, Typography } from '@mui/material'

export function Section({
  children,
  title,
  helperText,
}: {
  children: React.ReactNode
  title: string
  helperText?: string
}) {
  return (
    <Box mt={5}>
      <Typography variant="h2">{title}</Typography>

      {helperText && (
        <Typography variant="h6" color="textSecondary">
          {helperText}
        </Typography>
      )}

      {children}
    </Box>
  )
}

export function SubSection({ children, title }: { children: React.ReactNode; title?: string }) {
  return (
    <Box mt={5}>
      {title && <Typography variant="h4">{title}</Typography>}
      {children}
    </Box>
  )
}
